import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

const LANGUAGES = [
  { code: "en", label: "en" },
  { code: "he", label: "עב" },
] as const;

export default function AuthLangSwitcher() {
  const { i18n } = useTranslation();
  const currentLang = i18n.resolvedLanguage || i18n.language;

  return (
    <div className="fixed left-5 top-5 z-10 flex items-center gap-1.5 font-serif text-lg italic">
      {LANGUAGES.map((lang, idx) => (
        <span key={lang.code} className="flex items-center gap-1">
          {idx > 0 && <span className="text-muted-foreground/60">/</span>}
          <button
            type="button"
            onClick={() => i18n.changeLanguage(lang.code)}
            className={cn(
              "rounded px-1.5 py-0.5 transition-colors hover:text-primary",
              currentLang === lang.code
                ? "text-primary"
                : "text-muted-foreground",
            )}
          >
            {lang.label}
          </button>
        </span>
      ))}
    </div>
  );
}
